// extracted by mini-css-extract-plugin
export default {"badge":"interview-status-badge_badge__owvQ+","dot":"interview-status-badge_dot__wLhAi","pulse":"interview-status-badge_pulse__aUk6a"};